module.exports = __webpack_public_path__ + "img/pg4-article-title3-inner.ca12079e.png";